(ns ductile.ui.elog
  (:require [clojure.string :as str]
            [ductile.ui.components :as ui]
            [ductile.ui.components.combobox :as combobox]
            [ductile.ui.deframe :as deframe]
            [ductile.ui.http :as http]
            [ductile.ui.locale :refer [tr]]))


(def !selected-year-month
  (deframe/!route-get ::selected-year-month "2025-01"))

(def !customers
  (deframe/!route-get ::customers #{"BMW AG"}))

(defn month-selector []
  (let [current-month (.getMonth (js/Date.))
        month-names [(tr "January") (tr "February") (tr "March") (tr "April")
                     (tr "May") (tr "June") (tr "July") (tr "August")
                     (tr "September") (tr "October") (tr "November") (tr "December")]
        choices (reverse (map #(let [billing-month (js/Date.)
                                     _ (.setMonth billing-month %)
                                     month (+ 1 (.getMonth billing-month))
                                     month-name (get month-names (.getMonth billing-month))
                                     month (if (<= 10 month) (str month) (str "0" month))
                                     year (.getFullYear billing-month)]
                                 {:ui/value (str year "-" month) :ui/label (str month-name " " year)})
                              (range (- current-month 12) (inc current-month))))]
    [combobox/view
     {:placeholder (tr "Select billing month")
      :size 3
      :choices choices
      :value (some #(when (= @!selected-year-month (:ui/value %)) %) choices)
      :on-change #(deframe/route-assoc! ::selected-year-month (:ui/value %))}]))

(defn render-importer [_result _match]
  [:<>
   (when-let [error @(deframe/!route-get ::http/speculative-transaction-error)]
     [:div.mb-6
      [ui/expected-error-view error]])
   (let [pending-import @(deframe/!get ::elog-pending-import)
         on-import-done #(deframe/dissoc! ::elog-pending-import)
         import-button (fn [state-key {:keys [disabled on-click label] :as props}]
                         [ui/button
                          (merge props
                                 {:variant :primary
                                  :size 3
                                  :on-click (fn []
                                              (deframe/assoc! ::elog-pending-import state-key)
                                              (-> (on-click)
                                                  (.finally on-import-done)))
                                  :disabled? pending-import
                                  :loading? (= state-key pending-import)})
                          [:span
                           (or label
                               (if (= pending-import state-key)
                                 (tr "Importing")
                                 (tr "Import")))]])]
     [:div.bg-white.rounded-lg.shadow-lg.overflow-x-auto.mx-auto
      [:div.px-5.py-2.bg-slate-50.border-b
       [:div.leading-none.justify-between.flex.items-center.gap-4
        [:h2.text-base.font-bold (tr "ELOG Importer")]]]
      [:div
       [:div.px-5.py-2.tracking-wider.uppercase.font-bold.text-xs.border-b.leading-none.bg-slate-50.shadow-inner
        (tr "Single Vehicle")]
       [:div.flex.items-center.px-5.py-3.gap-3.border-b
        [:label.font-bold (tr "VIN")]
        [ui/input {:value @(deframe/!route-get ::vin "")
                   :on-input #(deframe/route-assoc! ::vin (.. % -target -value))
                   :class "flex-auto"
                   :size 3}]
        [import-button ::single-vehicle
         {:disabled (str/blank? @(deframe/!route-get ::vin))
          :on-click #(http/$enable-speculative-transactions!
                      {:ductile.datomic.speculative-transactions/init-txd 'ductile.elog.tx-import/single-fahrzeug-txd
                       :ductile.datomic.speculative-transactions/scope :session
                       :ductile.elog.tx-import/record-missing-data true
                       :vehicle/vin @(deframe/!route-get ::vin)
                       :compound/name @deframe/!current-compound})}
         (tr "Import")]]
       [:div
        [:div.px-5.py-2.tracking-wider.uppercase.font-bold.text-xs.border-b.leading-none.bg-slate-50.shadow-inner
         (tr "Session")]

        [:div.flex.items-center.justify-between.px-5.py-3.gap-3
         (tr "Start a new speculative session")

         [import-button ::empty-session
          {:label (tr "Start")
           :on-click #(http/$enable-speculative-transactions!
                       {:ductile.datomic.speculative-transactions/scope :session})}]]]

       [:div
        [:div.px-5.py-2.tracking-wider.uppercase.font-bold.text-xs.border-b.leading-none.bg-slate-50.shadow-inner
         (tr "Compound State")]
        [:div.flex.items-center.justify-between.px-5.py-3.gap-3
         (tr "All vehicles currently in %1" @deframe/!current-compound)

         [import-button ::all-vehicles
          {:on-click #(http/$enable-speculative-transactions!
                       {:ductile.datomic.speculative-transactions/init-db 'ductile.elog.tx-import/init-spec-db
                        :ductile.datomic.speculative-transactions/scope :session
                        :ductile.elog.tx-import/record-missing-data true
                        :compound/name @deframe/!current-compound})}]]]

       [:div
        [:div.px-5.py-2.tracking-wider.uppercase.font-bold.text-xs.border-b.leading-none.bg-slate-50.shadow-inner
         (tr "Invoices")]
        [:div.flex.items-center.px-5.py-3.gap-3
         [:label.flex-auto.text-slate-500 @deframe/!current-compound " " (tr "since")]
         [month-selector]
         [import-button ::invoices
          {:on-click #(http/$enable-speculative-transactions! {:ductile.datomic.speculative-transactions/init-txd 'ductile.elog.tx-import/invoice-data-txd
                                                               :ductile.datomic.speculative-transactions/scope :single-browser-tab
                                                               :compound/name @deframe/!current-compound
                                                               :year-month @!selected-year-month
                                                               :customers @!customers})}]]
        [:div.flex.items-center.px-5.py-3.gap-3
         (into [:ul.mb-4]
               (map (fn [customer-name]
                      [:label.flex.items-center.gap-2.py-1
                       {:for (str customer-name)}
                       [:input {:type :checkbox
                                :id (str customer-name)
                                :checked (boolean (@!customers customer-name))
                                :on-change (fn [event]
                                             (deframe/route-assoc! ::customers ((if (.. event -target -checked)
                                                                                  conj
                                                                                  disj)
                                                                                @!customers
                                                                                customer-name)))}]
                       customer-name]))
               #{"BMW AG"
                 "Tölke & Fischer Auto Link GmbH & Co"
                 "Sixt Leasing SE"
                 "Schwarz Beschaffung GmbH"})]]

       [:div
        [:div.px-5.py-2.tracking-wider.uppercase.font-bold.text-xs.border-b.leading-none.bg-slate-50.shadow-inner
         (tr "Contracts")]
        [:div.flex.items-center.px-5.py-3.gap-3
         [:label.flex-auto.text-slate-500 @deframe/!current-compound " "]

         [import-button ::billing-template {:on-click #(http/$enable-speculative-transactions!
                                                        {:ductile.datomic.speculative-transactions/init-txd 'ductile.elog.tx-import/billing-template-txd
                                                         :ductile.datomic.speculative-transactions/scope :single-browser-tab
                                                         :compound/name @deframe/!current-compound})}]]
        [:div.flex.items-center.px-5.py-3.gap-3
         [:label.flex-auto.text-slate-500 "Manuell"]
         [import-button ::fixed-templates
          {:on-click #(http/$enable-speculative-transactions!
                       {:ductile.datomic.speculative-transactions/init-txd 'ductile.elog.tx-import/fixed-templates-txd
                        :ductile.datomic.speculative-transactions/scope :single-browser-tab
                        :compound/name @deframe/!current-compound})}]]]]])])
